
import { useState } from 'react';
import { AvailableCoupon } from '@/hooks/useBookingCoupons';

export const useBookingState = () => {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string>("");
  const [selectedMembershipId, setSelectedMembershipId] = useState<string | null>(null);
  const [selectedCoupon, setSelectedCoupon] = useState<AvailableCoupon | null>(null);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [waiversCompleted, setWaiversCompleted] = useState(false);

  return {
    selectedDate,
    setSelectedDate,
    selectedTimeSlot,
    setSelectedTimeSlot,
    selectedMembershipId,
    setSelectedMembershipId,
    selectedCoupon,
    setSelectedCoupon,
    searchModalOpen,
    setSearchModalOpen,
    processing,
    setProcessing,
    waiversCompleted,
    setWaiversCompleted,
  };
};
